import React, { useRef, useEffect, useState } from 'react';
import styled from 'styled-components';
import ImageItem from '../shared/ImageItem';
import Video from './Video';

const AssetWrapper = styled.div`
  /* width: ${({ solo, portrait }) =>
    solo ? (portrait ? '100%' : '100%') : portrait ? '35%' : '50%'}; */
  margin: ${({ solo }) => (solo ? '0 auto 50px' : '0')};
  position: ${({ solo }) => (solo ? 'relative' : 'absolute')};
  transform: ${({ solo }) => (solo ? 'none' : 'translateX(-50%)')};
  cursor: pointer;
  width: ${({ portrait, portraitRatio, i, solo }) =>
    i === 1
      ? portrait
        ? portraitRatio > 1.25
          ? '30%'
          : '45%'
        : solo
        ? '75%'
        : '65%'
      : portrait
      ? portraitRatio > 1.25
        ? '25%'
        : '35%'
      : '42%'};
  /* height: 100%; */
  overflow: hidden;
  max-height: ${({ isVid, solo }) => isVid && solo ? 'calc(100vh - 60px)' : 'auto'};
  object-fit: contain;

  img,
  video {
    object-fit: contain !important;
    max-height: ${({ isVid, solo }) => isVid && solo ? 'calc(100vh - 60px)' : 'auto'};
  }

  img:first-of-type {
    object-fit: cover !important;
  }

  top: ${({ i, solo }) => {
    if (!solo) {
      switch (i) {
        case 1:
          return '0';
        case 2:
          return '30vh';
        case 3:
          return '15vh';
        default:
          return '0';
      }
    }
  }};

  left: ${({ i, solo }) => {
    if (!solo) {
      switch (i) {
        case 1:
          return '50%';
        case 2:
          return '27%';
        case 3:
          return '72%';
        default:
          return '50%';
      }
    }
  }};

  @media only screen and (max-width: 810px) {
    width: ${({ portrait, i, solo }) => {
      if (i === 1) {
        if (solo) {
          return '100%';
        } else {
          return portrait ? '60%' : '70%';
        }
      } else {
        return portrait ? '50%' : '60%';
      }
    }};

    top: ${({ i, solo }) => {
      if (!solo) {
        switch (i) {
          case 1:
            return '0';
          case 2:
            return '25vh';
          case 3:
            return '13vh';
          default:
            return '0';
        }
      }
    }};

    left: ${({ i, solo }) => {
      if (!solo) {
        switch (i) {
          case 1:
            return '50%';
          case 2:
            return '15px';
          case 3:
            return 'auto';
          default:
            return '50%';
        }
      }
    }};

    right: ${({ i, solo }) => {
      if (!solo) {
        switch (i) {
          case 1:
            return 'auto';
          case 2:
            return 'auto';
          case 3:
            return '14px';
          default:
            return 'auto';
        }
      }
    }};

    transform: ${({ i, solo }) => {
      if (!solo) {
        switch (i) {
          case 1:
            return 'translateX(-50%)';
          case 2:
            return 'none';
          case 3:
            return 'none';
          default:
            return 'translateX(-50%)';
        }
      }
    }};
  }
`;

const Img = ({
  image,
  i,
  solo,
  video,
  highestZ,
  setHighestZ,
  loop,
  checkHeights,
  loopWithSound,
  poster,
}) => {
  const [zInd, setZInd] = useState(highestZ);
  const [vidPortrait, setVidPortrait] = useState(false);
  const el = useRef(null);

  useEffect(() => {
    if (el.current) {
      const vid = el.current.querySelector('video');

      if (vid)
        vid.addEventListener('canplay', () => {
          if (vid.offsetHeight / vid.offsetWidth >= 1) {
            setVidPortrait(true);
          }
          checkHeights();
        });

      return () => {
        if (vid) vid.removeEventListener('canplay', () => checkHeights);
      };
    }
  }, []);

  return (
    <AssetWrapper
      i={i + 1}
      ref={el}
      // portrait={image && image.height / image.width > 1 || video}
      portrait={(image && image.height / image.width >= 1) || vidPortrait}
      portraitRatio={image && image.height / image.width}
      onClick={() => {
        setZInd(highestZ + 2);
        setHighestZ(highestZ + 2);
      }}
      onMouseEnter={() => {
        setZInd(highestZ + 2);
        setHighestZ(highestZ + 2);
      }}
      style={{ zIndex: zInd }}
      solo={solo}
      isVid={!!video}
    >
      {video ? (
        <Video
          loop={loop}
          video={video}
          loopWithSound={loopWithSound}
          poster={poster}
        />
      ) : (
        <ImageItem image={image} />
      )}
    </AssetWrapper>
  );
};

export default Img;
